import React, { useState } from 'react';
import { SettingsIcon } from './SettingsIcon';

interface SettingsIconButtonProps {
  onClick: () => void;
}

export function SettingsIconButton({
  onClick,
}: SettingsIconButtonProps): React.JSX.Element {
  const [isHovered, setIsHovered] = useState(false);

  const iconStyle = {
    color: isHovered ? '#0b682d' : '#000000',
    transform: isHovered ? 'scale(1.2) rotate(180deg)' : 'scale(1) rotate(0)',
    transition: 'all 0.3s ease',
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        cursor: 'pointer',
        zIndex: 1000,
        backgroundColor: '#F5F5F5',
        borderRadius: '50%',
        padding: '10px',
        boxShadow: 'rgba(1, 1, 1, 0.6) 0px 1px 5px 1px',
      }}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <SettingsIcon style={iconStyle} />
    </div>
  );
}
